<div class="modal-content p-3">
    <div class="modal-body">

        <div class="row">
            <button class="close" type="button" (click)="close()" [attr.disabled]="showSpinner ? true : null" ><i class="fa fa-times"></i></button>

            <div class="col-12">
                <app-alert-message *ngFor="let message of messages; let i = index"
                    [message]="message.text"
                    [isError]="message.isError"
                    [isSuccess]="message.isSuccess"
                    (close)="removeMessage(i)"
                ></app-alert-message>
            </div>

            <div class="col-sm-12">
                <h2 class="text-center mt-3">Solicitud de credito</h2>
                <h5 class="text-center"><span class="badge bg-secondary text-center">{{this.inputModel.rut | rutFormat}}</span></h5>
                <h3>Listado de Solicitudes</h3>
            </div>

            <ng-container *ngIf="showSpinner; else elseSpinner">
                <div class="col-sm-12 p-5">
                    <div class="row">
                        <div class="col-sm-12 d-flex justify-content-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="col-sm-12 text-center mt-1">
                            <span>Cargando...</span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #elseSpinner>
                <div class="col-sm-12">
                    <ng-container *ngIf="dataTable.length > 0">
                        <app-dynamic-colunm-table [data]='dataTable' [header]='header' [divider]="'normal'"
                            [groupHeader]='"listadoSolicitud"' [paginationExcluir]="false"
                            (funcional)='procesarEvent($event);'
                            [contentEditable]="hasUserAccess" [clasess]="'general table-bordered'">
                        </app-dynamic-colunm-table>
                    </ng-container>
                </div>
            </ng-template>
                
        </div>

    </div>
</div>
